
export const sortkey = <T, V>(key: (arg: T) => V, reverse?: boolean) => (a: T, b: T): number => {
	const ka = key(a);
	const kb = key(b);

	const smaller = reverse ? 1 : -1;
	const larger = reverse ? -1 : 1;

	if (Array.isArray(ka) && Array.isArray(kb) && ka.length === kb.length) {
		for (let i = 0; i < ka.length; i++) {
			const va = ka[i];
			const vb = kb[i];
			if (va !== vb) {
				return va < vb ? smaller : larger;
			}
		}

		return 0;
	}

	return ka < kb ? smaller : (ka > kb ? larger : 0);
};
